import { apiService } from './api';
import { MenuCategoryDTO, CreateMenuCategoryDTO } from '../types';

const API = '/menu-categories';

export const menuCategoryService = {
  getAll: (pageNumber = 1, pageSize = 100) =>
    apiService.get<{ data: MenuCategoryDTO[] }>(API, { pageNumber, pageSize }),

  getByType: (typeId?: number) =>
    apiService.get<{ data: MenuCategoryDTO[] }>(API, typeId ? { typeId, pageNumber: 1, pageSize: 200 } : { pageNumber: 1, pageSize: 200 }),

  getById: (id: number) =>
    apiService.get<MenuCategoryDTO>(`${API}/${id}`),

  create: (data: CreateMenuCategoryDTO) =>
    apiService.post<MenuCategoryDTO>(API, data),

  update: (id: number, data: Partial<CreateMenuCategoryDTO>) =>
    apiService.put<MenuCategoryDTO>(`${API}/${id}`, data),

  delete: (id: number) =>
    apiService.delete<boolean>(`${API}/${id}`),
};
